import { Questionnaire } from "src/graphql/generated/graphql";

import { QuestionnairePreview } from "../../../../QuestionnairePreview";

export interface AssignmentQuestionnaireDetailProps {
    questionnaire: Questionnaire;
}

export const AssignmentQuestionnaireDetail = ({ questionnaire }: AssignmentQuestionnaireDetailProps) => {
    return <QuestionnairePreview questionnaire={questionnaire} />;
};
